export default __webpack_public_path__ + "static/media/vida_security_sbs.c1065761.jpg";